import * as Html from "../util/Html.ts";
import * as i18n from "../i18n.ts";
import { digit2 } from "../lib/DateUtils.ts";

Html.registerWidget('widget/countdown-promo',{initDom,destroyDom})

function initDom(dom :HTMLElement){
  var
    date = new Date(dom.getAttribute('data-date')).getTime(),
    updater = ()=>{
    var
      now = new Date().getTime(),
      deltaSeconds = Math.floor((date-now)/1000),
      deltaDays,
      deltaHours,
      deltaMinutes;

    deltaDays  = Math.floor(deltaSeconds/3600/24)
    deltaHours = Math.floor(deltaSeconds/3600);
    deltaSeconds -= deltaHours * 3600;
    deltaMinutes = Math.floor(deltaSeconds/60);
    deltaSeconds -= deltaMinutes * 60;

    if(deltaDays>=3){
      dom.innerText = i18n.get('deltatime.onlydaysleft',deltaDays)

    }else{
      dom.innerText = digit2(deltaHours)+':'+digit2(deltaMinutes)+':'+digit2(deltaSeconds)
    }

  };
  updater()
  dom.setAttribute("data-interval",setInterval(updater ,1000))
}

function destroyDom(dom :HTMLElement){
  clearInterval(parseInt(dom.getAttribute("data-interval")))
}
